import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import WordVoice from '../audio/WordVoice';
import Confirmation from './Confirmation'

import styles from './SelfEval.css';


const DEFAULT_REMAIN_SECONDS = 180;
const INTERVAL_REMEMBERED_RESULT = 3000
const INTERVAL_NOTREMEMBERED_RESULT = 5000

class SelfEvalControl extends Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.result = [];
    this.rememberedCount = 0;
    this.notRememberedCount = 0;
    this.state = {
      started: false,
      audioPrepared: false,
      questionIndex: -1,
      endDateTime: 0,
      remainSeconds: DEFAULT_REMAIN_SECONDS,
      phase: 'confirmation',
      question: '',
      answer: '',
      confirmStarted: null,
      confirmDuration: null,
    };
  }

  copyState() {
    return Object.assign({}, this.state);
  }

  componentDidUpdate() {
    setTimeout(() => {
      const state = this.copyState();
      state.started = this.props.started && (!this.props.enableAudio || this.state.audioPrepared);
      if (this.state.started != state.started) {
        this.setState(state);
        if (state.started) {
          this.start();
        }
      }
    }, 100);
  }

  finished(abort) {
    clearInterval(this.timer);
    this.result.push({
      action: abort ? 'abort' : 'finish',
      time: Date.now()
    });
    console.log('Finished');
    const self = this;
    setTimeout(() => {
      if (self.props.onFinish) {
        let summary = '';
        const score = `「覚えていた」数 ${this.rememberedCount} / 単語数 ${this.rememberedCount + this.notRememberedCount}`
        if (!abort) {
          summary = `英単語学習を実施しました: ${score}`;
        } else {
          summary = `英単語学習を中断しました: ${score}`;
        }
        self.props.onFinish({events: self.result, summary: summary});
      }
    }, 500);
  }

  abort() {
    this.finished(true);
  }

  audioLoaded(ev) {
    const state = this.copyState();
    state.audioPrepared = true;
    this.setState(state);
    if (!this.props.audioLoaded) {
      return;
    }
    this.props.audioLoaded(ev)
  }

  start() {
    if (this.timer) {
      return;
    }
    console.log('Started');
    const currentTime = Date.now();
    const remainSeconds = this.props.timeout || DEFAULT_REMAIN_SECONDS;
    const state = this.copyState();
    state.endDateTime = currentTime + remainSeconds * 1000;
    state.questionIndex = -1;
    state.remainSeconds = remainSeconds;
    this.setState(state, () => {
      this.nextQuestion();
      const self = this;
      this.timer = setInterval(() => {
        self.refreshTimer();
      }, 250);
    });
  }

  nextQuestion() {
    const questionIndex = this.state.questionIndex + 1;
    console.log('Question', questionIndex, this.props.data);
    if (questionIndex >= (this.props.data ? this.props.data.length : 0)) {
      const state = this.copyState();
      state.questionIndex = questionIndex;
      this.setState(state);
      this.finished(false);
      return;
    }
    const question = this.props.data[questionIndex];
    this.result.push({
      action: 'start',
      time: Date.now(),
      question: question
    });
    const state = this.copyState();
    state.phase = 'confirmation';
    state.questionIndex = questionIndex;
    state.question = question.text;
    state.answer = question.answers[question.answerIndex].text;
    state.example = this.findExample(state.question)
    state.confirmStarted = null
    state.confirmDuration = null
    this.setState(state);
    if (this.props.enableAudio) {
      this.refs.voice.play(`${this.props.audioURL || '/task/ngsl/word/'}${question.text}`);
    }
  }

  findExample(question) {
    if (!this.props.examples) {
      return null
    }
    const examples = this.props.examples[question]
    if (!examples || examples.length == 0) {
      return null
    }
    return examples[Math.floor(Math.random() * examples.length)]
  }

  confirmClicked() {
    if (this.state.confirmStarted) {
      return
    }
    const question = this.props.data[this.state.questionIndex];
    this.result.push({
      action: 'confirm',
      time: Date.now(),
      question,
    });
    const state = this.copyState();
    state.phase = 'evaluation';
    this.setState(state);
  }

  answerClicked(remembered) {
    if (this.state.confirmStarted) {
      return
    }
    const question = this.props.data[this.state.questionIndex];
    this.result.push({
      action: 'answer',
      time: Date.now(),
      question,
      example: this.state.example || null,
      remembered
    });
    let interval = INTERVAL_REMEMBERED_RESULT
    if (remembered) {
      this.rememberedCount ++;
    } else {
      this.notRememberedCount ++;
      interval = INTERVAL_NOTREMEMBERED_RESULT
    }
    this.setState({
      confirmStarted: Date.now(),
      confirmDuration: interval,
    })
    setTimeout(() => {
      this.nextQuestion();
    }, interval);
  }

  refreshTimer() {
    const remainSeconds = (this.state.endDateTime - Date.now()) / 1000;
    if (remainSeconds < 0) {
      this.finished(false);
      return;
    }
    const state = this.copyState();
    state.remainSeconds = parseInt(remainSeconds);
    this.setState(state);
  }

  problemReported() {
    if (!this.props.problemReported) {
      return
    }
    const question = this.props.data[this.state.questionIndex];
    this.props.problemReported({
      question,
      example: this.state.example || null,
    })
  }

  render() {
    return (
      <div
        className={styles.SelfEval}
        class="uk-height-1-1"
        style={{display: this.props.started ? 'block' : 'none'}}>
        <nav class="uk-navbar-container" uk-navbar>
          <div class="uk-navbar-center">
            <ul class="uk-navbar-nav">
              <li>
                <a
                  href='#'
                  onClick={ev => this.abort()}
                  class="uk-button-danger">
                  中断
                </a>
              </li>
              <li>
                <a href="#">
                  <span class="word-stats">
                    <span id="word_index">
                      {this.state.questionIndex < 0 ? '-' : this.state.questionIndex + 1}
                    </span>&nbsp;/&nbsp;
                    <span id="word_count">{this.props.data ? this.props.data.length : 0}</span>単語
                    &nbsp;&nbsp;&nbsp;
                    残り
                    <span id="remain_time">
                      {parseInt(this.state.remainSeconds / 60)}:{this.state.remainSeconds % 60 < 10 && '0'}{this.state.remainSeconds % 60}
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <div
          className={styles.SelfEvalContent}
          class="uk-section uk-flex uk-flex-center uk-flex-middle uk-text-center content"
          uk-height-viewport="offset-top: true; offset-bottom: true">
          <div>
            <h1 className={styles.SelfEvalQuestion}>{this.state.question}</h1>
            {this.state.phase == 'evaluation' && <div className={styles.SelfEvalAnswer}>{this.state.answer}</div>}
            {this.state.confirmStarted &&
              <Confirmation
                started={this.state.confirmStarted}
                duration={this.state.confirmDuration}
                example={this.state.example}
                word={this.state.question}
                disableProblemReport={this.props.disableProblemReport}
                problemReported={() => this.problemReported()}
              />}
          </div>
          <WordVoice
            ref='voice'
            onLoad={ev => this.audioLoaded(ev)}
            urls={((this.props.enableAudio ? this.props.data : null) || []).map(question => `${this.props.audioURL || '/task/ngsl/word/'}${question.text}`)} />
        </div>
        <div class="uk-flex uk-flex-column uk-width-1-1">
          <div class="uk-grid-medium uk-child-width-expand@s" uk-grid>
            {this.state.phase == 'confirmation' &&
              <div class="button-answer">
                <button
                  onClick={ev => this.confirmClicked(true)}
                  class="uk-button uk-button-large uk-width-1-1 button-answer uk-text-left">
                  <span class="button-text">意味を確認！</span>
                </button>
              </div>}
            {this.state.phase == 'evaluation' &&
              <div>
                <div class="button-answer">
                  <button
                    onClick={ev => this.answerClicked(true)}
                    class="uk-button uk-button-large uk-width-1-1 button-answer uk-text-left uk-button-primary">
                    <span class="button-text">覚えていた</span>
                  </button>
                </div>
                <div class="button-answer">
                  <button
                    onClick={ev => this.answerClicked(false)}
                    class="uk-button uk-button-large uk-width-1-1 button-answer uk-text-left uk-button-danger">
                    <span class="button-text">覚えていなかった</span>
                  </button>
                </div>
              </div>}
          </div>
          <div class="bottom-margin"></div>
        </div>
      </div>
    );
  }
}

export default SelfEvalControl;
